
<div class="container-lg container-xl bg-white cornerr">
    <div class="row">
        <div class="d-none d-md-block col-md-2"></div>
        <div class="col-12 col-md-8 pt-2">
            <div class="card card-profile">
                <div class="">
                  <a href="#">
                    <img class="img rounded" src="https://nld.gob.mx/assets/img/carmen.png" style="max-width: 300px;">
                  </a>
                </div>
                <div class="card-body ">
                    <a routerLink="/mensaje" href="#" style="text-decoration: none;">
                        <h6 class="card-category text-gray colorSecundario">Mensaje de la Presidenta Municipal</h6>
                    </a>
                    <a routerLink="/mensaje" href="#" style="text-decoration: none;">
                        <h4 class="card-title">Carmen Lilia Canturosas</h4>
                    </a>
    
                    
    
                      <p style="text-align: justify;">
                        En Nuevo Laredo comenzó a escribirse una nueva historia de esperanza, donde gobierno municipal y ciudadanos habremos de trabajar unidos para devolver a la ciudad su dignidad y su grandeza. </p>
                        <p style="text-align: justify;">
                        Tenemos el compromiso y la firme convicción de transformar la realidad de las familias neolaredenses, a través de políticas verdaderamente humanistas donde el ciudadano será la columna vertebral del gobierno municipal.</p>
                        <p style="text-align: justify;">
                        En esta nueva era impulsaremos las ventajas competitivas de Nuevo Laredo, seremos aliados de los empresarios y principales actores del comercio internacional para que nuestra aduana se consolide como la número uno de México y América Latina.
                        </p>
                        <p style="text-align: justify;">
                        Es momento de colocar a la ciudad en el lugar que se merece, de caminar en unidad hacía un mismo objetivo con la fuerza, el empuje y la determinación que nos caracteriza a los neolaredenses.
                        </p>
                        <p style="text-align: justify;">
                        Mi compromiso como alcaldesa de Nuevo Laredo es inquebrantable, llevaremos bienestar y progreso a todos los rincones de la ciudad y haremos que los ciudadanos se sientan orgullosos de vivir en esta tierra de oportunidades.
                        </p>
                        <p style="text-align: justify;">
                        Hemos conformado un equipo de trabajo con los mejores hombres y mujeres, quienes de la mano del ciudadano habrán de construir una nueva realidad para todas y todos los que habitan en esta frontera.
                        </p>
                        <p style="text-align: justify;">
                        Llegó el momento del cambio verdadero, llegó el momento de la unidad, del trabajo en equipo… llegó el momento de sentirnos orgullosos de nuestra tierra y que en cada rincón de México se escuche fuerte el latido de Nuevo Laredo, el nuevo corazón de Tamaulipas.
                       </p>
                      <div class="d-flex justify-content-end mt-4">
                <!--
                        <a href="https://twitter.com/Carmenliliacrv?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-show-count="false">Follow @Carmenliliacrv</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                -->
                    </div>
                      
                     
                     
                      
                </div>
            </div>
          
        </div>
        <div class="d-none d-md-block col-md-2"></div>
    </div>
    
    </div>
    
